import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader, {isAdvancedMode} from "../components/PageHeader";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import NotesPanel from "../notes/panels/NotesPanel";
import ActionButton from "../components/ActionButton";
import OrderDetails from "./views/OrderDetails";
import OrderList from "./views/OrderList";
import OrderInfoPanel from "./panels/OrderInfoPanel";
import ShippingInfoPanel from "../shipping/panels/ShippingInfoPanel";
import ShippingStatusPanel from "../shipping/panels/ShippingStatusPanel";
import {getAllShopsWithAllOption} from "../lib/Shops";
import {
  requestCancelSalesOrder 
  } from "../actions/SalesApiActions";
import {connect} from "react-redux";
import gql from "graphql-tag";
import {withApollo} from "react-apollo";
import {List, fromJS, Map} from "immutable";
import { requestCreateNote } from "../notes/NotesActions";
import { SALES_ORDER_TYPE } from '../notes/notes';

const billingStatusFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "paid", label: "Paid"},
  {id: "not_paid", label: "Not Paid"},
  {id: "voided", label: "Voided"}
])

const typeFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: "subscription", label: "Subscriptions"},
  {id: "new_subscription", label: "New Subscriptions"},
  {id: "one_time", label: "One-Time Orders"},
  {id: "gift", label: "Gifts"},
  {id: "promo", label: "Promos"}
])

const searchOptions = fromJS([
  {prop: "orderId", label: "Order Id", type: "string"},
  {prop: "invoiceNr", label: "Invoice Nr", type: "string"},
  {prop: "billingName", label: "Billing Name", type: "string"},
  {prop: "shippingName", label: "Shipping Name", type: "string"},
  {prop: "promoCode", label: "Promo Code", type: "string"},
])


class OrdersPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleViewOrderId = this.handleViewOrderId.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      orderId: "",
      hasOrderSelection: false,
      selectedPanelId: "general",
      shopFilter: "",
      billingStatusFilter: "",
      typeFilter: ""
    }
  }

  componentDidMount() {
    if (this.props.route.page === "order") {
      this.setState({orderId: this.props.params.orderId, selectedPanelId: "properties"});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let changes = false;
    let newState = {};
    if (prevProps.params.orderId !== this.props.params.orderId) {
      changes = true;
      newState.orderId = this.props.params.orderId;
    }
    if (this.props.route.page === "order" && (this.state.selectedPanelId === "general" || this.state.selectedPanelId === "search")) {
      changes = true;
      newState.selectedPanelId = "properties";
    }

    if (changes) {
      this.setState(newState);
    }
  }

  render() {
    const page = this.props.route.page;
    
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Orders";
    if (page === "order") {
      title = `${title} / ${this.state.orderId}`;
    }

    const baseClasses = [
      "SalesPage OrdersPage SecurePage",
      isAdvancedMode(this.props.router.location.query) ? "advancedMode" : null,
    ];

    return (
      <div className={baseClasses.join(" ")}>
        <AppSidebar />
        <PageHeader title={title} backButton={page === "order"} onBack={this.handleBack}
          advancedModeToggle router={this.props.router} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={page==="orders"} label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="orders"} label="Search" id="search" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={true} label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order"} label="Shipping" id="shipping" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="order" || this.state.hasOrderSelection} label="Notes" id="notes" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Cancel Order" 
              show={page === "order"}
              onClick={this.handleCancelOrder.bind(this)} />
            <ActionButton 
              label="Annotate Order" 
              show={(page === "orders" && this.state.hasOrderSelection) || page === "order"}
              onClick={this.handleAnnotateOrder.bind(this)} />

          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);

    switch(page) {
      case "orders":
        return (
          <OrderList 
            selectedId={this.state.orderId} 
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleViewOrderId}
            shopFilter={this.state.shopFilter}
            billingStatusFilter={this.state.billingStatusFilter}
            typeFilter={this.state.typeFilter}
            billingNameSearch={searchQueries.get("billingName", "")}
            shippingNameSearch={searchQueries.get("shippingName", "")}
            invoiceNrSearch={searchQueries.get("invoiceNr", "")}
            orderIdSearch={searchQueries.get("orderId", "")}
            promoCodeSearch={searchQueries.get("promoCode", "")}
            advancedMode={isAdvancedMode(this.props.router.location.query)}
            />
        );
      case "order":
        return (
          <OrderDetails
            orderId={this.state.orderId}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "orders":
        if (this.state.selectedPanelId === "general") {
          return this.buildPanels(List(["shopFilter", "billingStatusFilter", "typeFilter"]));
        } else if (this.state.selectedPanelId === "properties" && this.state.hasOrderSelection) {
          return this.buildPanels(List([OrderInfoPanel]));
        } else if (this.state.selectedPanelId === "search") {
          return this.buildPanels(List([SearchQueriesPanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }
        break;
      case "order":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([OrderInfoPanel]));
        } else if (this.state.selectedPanelId === "shipping") {
          return this.buildPanels(List([ShippingStatusPanel, ShippingInfoPanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }
        break;
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "shopFilter":
        return <FilterPanel
          key="ShopFilterPanel"
          title="Shop Filter"
          expanded={true}
          options={getAllShopsWithAllOption()}
          onClick={this.handleSetShopFilter.bind(this)}
          filter={this.state.shopFilter}
          />      

      case "billingStatusFilter":
        return <FilterPanel
          key="BillingStatusFilterPanel"
          title="Billing Status Filter"
          expanded={true}
          options={billingStatusFilterOptions}
          onClick={this.handleSetBillingStatusFilter.bind(this)}
          filter={this.state.billingStatusFilter}
          />        

      case "typeFilter":
        return <FilterPanel
          key="TypeFilterPanel"
          title="Type Filter"
          expanded={true}
          options={typeFilterOptions}
          onClick={this.handleSetTypeFilter.bind(this)}
          filter={this.state.typeFilter}
          />     

      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />

      case "transactionDetails":
        return <PanelGroupController title="Transaction Details" />

      case OrderInfoPanel:
        return <OrderInfoPanel key="OrderInfoPanel" orderId={this.state.orderId} />

      case ShippingStatusPanel:
        return <ShippingStatusPanel key="ShippingStatusPanel" orderId={this.getOrderShippingId(this.state.orderId)} />

      case ShippingInfoPanel:
        return <ShippingInfoPanel 
                  key="ShippingInfoPanel" 
                  orderId={this.getOrderShippingId(this.state.orderId)} 
                  title="Shipping Order Info" />

      case NotesPanel:
        return <NotesPanel key="NotesPanel" foreignType={SALES_ORDER_TYPE} foreignId={this.state.orderId} />            

      default:
        return null;      
    }
  } 

  getOrderShippingId() {
    const result = this.props.client.readFragment({
      id: `sales-order:${this.state.orderId}`,
      fragment: gql`
        fragment myFrag on SalesOrder {
          shippingOrderId
        }
      `
    });      
    return result.shippingOrderId;
  }

  handleSetShopFilter(item) {
    this.setState({
      shopFilter: item.get("id")
    });
  }     

  handleSetBillingStatusFilter(item) {
    this.setState({
      billingStatusFilter: item.get("id")
    });
  }     

  handleSetTypeFilter(item) {
    this.setState({
      typeFilter: item.get("id")
    });
  }  

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: "/sales/orders",
      query: searchQueries.toJS()
    });
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: "/sales/orders",
      query: emptySearchQueries.toJS()
    });
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }

  handleSetSelection(id) {
    this.setState({orderId: id, hasOrderSelection: true, selectedPanelId: "properties"});
  }

  handleViewOrderId(orderId) {
    this.setState({orderId: orderId, hasOrderSelection: true}) 
    this.props.router.push(`/sales/orders/${orderId}`);    
  }  

  handleCancelOrder() {
    this.props.requestCancelSalesOrder(this.state.orderId);
  }

  handleBack() {
    this.props.router.push(`/sales/orders`);
  }  

  handleAnnotateOrder(e) {
    this.props.requestCreateNote(SALES_ORDER_TYPE, this.state.orderId);  
  }

}

export default connect(null, {requestCancelSalesOrder, requestCreateNote})(withApollo(OrdersPage));